
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-ai/loading",
      function () {
        return require("private-next-pages/create-ai/loading.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-ai/loading"])
      });
    }
  